/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import AdminEditControlModal from "./admin";
import { getUserInfo } from "../../../helpers/user";
import UserViewControlModal from "./user";

const EditControlPageRouteWrapper = () => {
  const userInfo = getUserInfo();

  if (userInfo.role === "admin") {
    return <AdminEditControlModal mode="page" />;
  } else if (
    userInfo.role === "user" ||
    userInfo.role === "auditor" ||
    userInfo.role === "org_admin"
  ) {
    return <UserViewControlModal />;
  } else {
    return <Navigate to="/login" />;
  }
};

export default EditControlPageRouteWrapper;
